/* unplugin-vue-components disabled */import { render } from "./input-text.vue?vue&type=template&id=0e33de9b&scoped=true"
import script from "./input-text.vue?vue&type=script&lang=js"
export * from "./input-text.vue?vue&type=script&lang=js"

import "./input-text.vue?vue&type=style&index=0&id=0e33de9b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e33de9b"],['__file',"src/components/chat-input-v2/input-text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e33de9b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e33de9b', __exports__)) {
    api.reload('0e33de9b', __exports__)
  }
  
  module.hot.accept("./input-text.vue?vue&type=template&id=0e33de9b&scoped=true", () => {
    api.rerender('0e33de9b', render)
  })

}


export default __exports__